module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community_select"
  }, [(_vm.selectedMetricCategory == null) ? _c('h5', [_vm._v(_vm._s("Select a metric above to display communities"))]) : _c('div', {
    staticStyle: {
      "height": "inherit"
    }
  }, [_c('div', {
    staticClass: "selection_mode_options"
  }, [_c('h5', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.selectionBoxMode))]), _vm._v(" "), _c('select-box-dropdown', {
    staticClass: "right",
    staticStyle: {
      "display": "inline-block",
      "margin-top": "1rem",
      "margin-right": ".5rem"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "selection_listing"
  }, [(_vm.selectionBoxMode === 'Communities') ? _c('community-list') : _vm._e(), _vm._v(" "), (_vm.selectionBoxMode === 'AEA Energy Regions') ? _c('aeaenergyregion-list') : _vm._e(), _vm._v(" "), (_vm.selectionBoxMode === 'Census Areas') ? _c('census-area-list') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "selection_footer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterBoxText),
      expression: "filterBoxText"
    }],
    staticStyle: {
      "vertical-align": "bottom"
    },
    attrs: {
      "placeholder": "Search table..."
    },
    domProps: {
      "value": (_vm.filterBoxText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterBoxText = $event.target.value
      }, _vm.updateFilter]
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4790f2c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommunitySelectBox.vue
// module id = 143
// module chunks = 1